import { render } from "./UpdateTime.vue?vue&type=template&id=872180c2&ts=true"
import script from "./UpdateTime.vue?vue&type=script&lang=ts"
export * from "./UpdateTime.vue?vue&type=script&lang=ts"

import "./UpdateTime.vue?vue&type=style&index=0&id=872180c2&lang=css"

import exportComponent from "F:\\hotaru_theme_for_RustVersion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__